import { useQuery } from '@tanstack/react-query';
import {
  fetchAdminTenantStatus,
  fetchAdminTenantUptime,
  fetchAdminTenantIncidents,
  fetchAdminTenantMaintenances,
} from '../api/tenant-status.api.ts';

const keys = {
  status: (id: string) => ['admin', 'tenants', id, 'status'] as const,
  uptime: (id: string, raw: boolean, semManutencao: boolean) =>
    ['admin', 'tenants', id, 'uptime', raw ? 'real' : 'contratual', semManutencao ? 'sem-manut' : 'com-manut'] as const,
  incidents: (id: string) => ['admin', 'tenants', id, 'incidents'] as const,
  maintenances: (id: string) => ['admin', 'tenants', id, 'maintenances'] as const,
};

export function useAdminTenantStatus(tenantId: string) {
  return useQuery({
    queryKey: keys.status(tenantId),
    queryFn: () => fetchAdminTenantStatus(tenantId),
    refetchInterval: 60_000,
  });
}

export function useAdminTenantUptime(tenantId: string, raw = false, excludeMaintenance = false) {
  return useQuery({
    queryKey: keys.uptime(tenantId, raw, excludeMaintenance),
    queryFn: () => fetchAdminTenantUptime(tenantId, raw, excludeMaintenance),
    refetchInterval: 5 * 60_000,
  });
}

export function useAdminTenantIncidents(tenantId: string) {
  return useQuery({
    queryKey: keys.incidents(tenantId),
    queryFn: () => fetchAdminTenantIncidents(tenantId),
    refetchInterval: 60_000,
  });
}

export function useAdminTenantMaintenances(tenantId: string) {
  return useQuery({
    queryKey: keys.maintenances(tenantId),
    queryFn: () => fetchAdminTenantMaintenances(tenantId),
    refetchInterval: 5 * 60_000,
  });
}
